import React from 'react';

export default props => {
  const { url, openTab } = props.contentState.getEntity(props.entityKey).getData();
  const otherProps = openTab ? { target: '_blank' } : {};

  return (
    <a href={url} {...otherProps} style={{ color: '#3b5998', textDecoration: 'underline' }}>
      {props.children}
    </a>
  );
};
